import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PurchaseRequests/PendingPurchaseRequests';

const PendingPurchaseRequests = () => ((orgContainer(InnerComponent)));

export default PendingPurchaseRequests;
